{
  "name": "web-app",
  "version": "3.1793841174.2735",
  "description": "",
  "license": "",
  "private": true,
  "sideEffects": [
    "**/*.css",
    "src/utils/polyfill/*.ts"
  ],
  "type": "module",
  "scripts": {
    "dev": "vite --force",
    "build": "cross-env NODE_OPTIONS=--max-old-space-size=8192 vite build --mode production",
    "format": "prettier './src/**/*.{ts,tsx,js,jsx,json}' --check",
    "format:fix": "prettier './src/**/*.{ts,tsx,js,jsx,json}' --write",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit",
    "lint": "eslint 'src/**/*.{js,jsx,ts,tsx}' --max-warnings 0",
    "lint:fix": "eslint 'src/**/*.{js,jsx,ts,tsx}' --fix"
  },
  "engines": {
    "node": ">=24"
  }
}
